import React, { useEffect, useState } from "react";
import { BellRing, X } from "lucide-react";
import { toast } from "sonner";
import { pushSupported, isPushEnabled, enablePush } from "../lib/push";
import { useI18n } from "../i18n";

/* Nudge to turn on device push so "🎉 You won ₹X" lands the second a show declares — even with the app closed. */
export const ResultAlertsPrompt = () => {
  const { lang } = useI18n();
  const ta = lang === "ta";
  const [show, setShow] = useState(false);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    if (!pushSupported() || localStorage.getItem("rl_result_alerts_dismissed")) return;
    isPushEnabled().then((on) => setShow(!on));
  }, []);
  if (!show) return null;
  const enable = async () => {
    setBusy(true);
    try { await enablePush(); toast.success(ta ? "Result alerts ON — வெற்றி வந்த உடனே push வரும்" : "Result alerts ON — you'll get a push the moment you win"); setShow(false); } catch (e) { toast.error(e.message || "Could not enable"); } finally { setBusy(false); }
  };
  return (
    <div className="rounded-2xl bg-slate-900 text-white p-3 flex items-start gap-3" data-testid="result-alerts-prompt">
      <BellRing className="w-5 h-5 text-amber-300 shrink-0 mt-0.5" />
      <div className="flex-1 text-xs">
        <div className="font-bold">{ta ? "\"உங்கள் bet ₹X வென்றது\" — show declare ஆன உடனே alert" : "\"Your bet won ₹X\" — the moment a show declares"}</div>
        <div className="text-slate-300 mt-0.5">{ta ? "App மூடியிருந்தாலும் phone-ல் notification வரும். Result-ஐ காத்திருந்து பார்க்க வேண்டாம்." : "Lands on your phone even when the app is closed, so you never wait for a result."}</div>
        <button onClick={enable} disabled={busy} className="mt-2 rl-gold-bg text-slate-900 font-bold text-xs px-3 py-1.5 rounded-xl disabled:opacity-60" data-testid="result-alerts-enable">{busy ? "…" : ta ? "Result alerts ON பண்ணு" : "Turn on result alerts"}</button>
      </div>
      <button onClick={() => { localStorage.setItem("rl_result_alerts_dismissed", "1"); setShow(false); }} className="p-0.5 text-slate-400" data-testid="result-alerts-dismiss"><X className="w-4 h-4" /></button>
    </div>
  );
};
